import { ArgumentError } from '../utils/errors';
import { BaseAPIModel } from '@weezevent/weezjs-core';
// import { fetcher } from '@weezevent/weezjs-core'

export default class TransfersStatusModel extends BaseAPIModel {
    static list(item) {
        return item;
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError(`[Model][TransfersModel][listUrl] organizationId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/accountancy/transfers/status`;
    }
}
